import { Component, OnInit } from '@angular/core';
import { gsap } from 'gsap';

@Component({
  selector: 'app-anim-telecom',
  templateUrl: './anim-telecom.component.html',
  styleUrls: ['./anim-telecom.component.scss']
})
export class AnimTelecomComponent implements OnInit {
  tlWave = gsap.timeline({ repeat:-1 });
  tlWifiLight = gsap.timeline({ repeat: -1 });
  tlWifiCircle = gsap.timeline({ repeat: -1 });
  
  constructor() { }

  ngOnInit(): void {
    this.animateWave();
    this.animateWifiLight();
    this.animateWifiCircle();
  }

  ngOnDestroy(): void{
    this.tlWave.kill();
    this.tlWifiLight.kill();
    this.tlWifiCircle.kill();
  }

  animateWave() {
    // let tl = gsap.timeline({ repeat:-1 });
    let waves = document.querySelectorAll('.wave');

    waves.forEach(wave => {
      this.tlWave.to(wave, { opacity: 1, duration: 0.5 });
    });
    waves.forEach(wave => {
      this.tlWave.to(wave, { opacity: 0, duration: 0.5 });
    });
  }

  animateWifiCircle() {
    let duration = 2;
    // let tlWifiCircle = gsap.timeline({ repeat: -1 });
    this.tlWifiCircle.set('.wifi-2', { y: -20 });
    this.tlWifiCircle.to('.wifi-1', { y: -20, duration })
      .to('.wifi-2', { y: 0, duration })
      .addLabel('pause1', '>+=' + duration)
      .to('.wifi-1', { y: 0, duration }, 'pause1')
      .to('.wifi-2', { y: -20, duration })
      .addLabel('pause2', '>+=' + duration)
 }

  animateWifiLight() {
    let duration = 0.75;
    // let tl = gsap.timeline({ repeat: -1 });
    this.tlWifiLight.set('.wifi .light.bottom', { fill: 'white' });
    this.tlWifiLight.set('.wifi .light.top', { fill: 'white' }, ">+=" + duration);
    this.tlWifiLight.set('.wifi .light.bottom', { fill: '#68a3d6' }, ">+=" + duration);
    this.tlWifiLight.set('.wifi .light.top', { fill: '#68a3d6' }, ">+=" + duration);
  }
}
